import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";

const StartPagesForm = lazy(
  () => import("../components/administration/channels/StartPagesForm"),
);

// Connects to data-controller="channel-start-pages-form"
// Intended be used on a div container
export default class extends Controller {
  connect() {
    const container = document.createElement("div");
    this.element.insertAdjacentElement("afterend", container);
    this.root = createRoot(container);
    this.root.render(
      <QueryClientProvider>
        <Suspense fallback={null}>
          <StartPagesForm />
        </Suspense>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    this.root?.unmount();
  }
}
